import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { UitkRadioGroup } from 'uitk-react-switch';
import { ActivityDestinationViewSearch } from '../../../common/__generated__/api';
import { RadioButtonTracked } from '../../../utils/click-trackers';
import { useStores } from '../../../utils/hooks';
import { refreshAds } from '../../../utils/refresh-ads';
import Options = ActivityDestinationViewSearch.Options;
import Fields = ActivityDestinationViewSearch.Fields;

export interface RadioProps {
  inDialog?: boolean;
  field: Fields;
  selectedField?: string;
  sectionName?: string | null;
}

export const Radio: React.FC<RadioProps> = observer(({ inDialog, selectedField, field, sectionName }) => {
  const { activitySearchStore, routeStore } = useStores();
  const categoryName = field.label || sectionName?.split(' ').join('-') || '';

  const radioClickHandler = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const [fieldId, fieldVal] = event.target.id.split('-');
    if (fieldId === 'sort') {
      activitySearchStore.sortAndFilterObject.initialSelectedSort = fieldVal;
      if (!inDialog) {
        const newQueryString = routeStore.mergeQueryString(routeStore.search, {
          sort: activitySearchStore.sortAndFilterObject.initialSelectedSort
        });
        routeStore.updateSearch(newQueryString, {}, true);
        refreshAds();
      }
    }
  };

  return (
    <UitkRadioGroup group={categoryName} selected={selectedField} onChange={radioClickHandler}>
      {(field as ActivityDestinationViewSearch.ActivitySelectionFieldInlineFragment).options.map((option: Options) => (
        <RadioButtonTracked
          data-testid={`${(field as Fields).id}--radio--${option.value}`}
          key={`sort-${option.value}`}
          id={`${(field as Fields).id}-${option.value}`}
          name={option.value}
          label={option.primary}
          value={option.value}
          rfrr={option.analytics?.referrerId}
          linkName={option.analytics?.linkName}
        />
      ))}
    </UitkRadioGroup>
  );
});
